import { init, track, setUserId, identify, Identify, flush } from "@amplitude/analytics-browser";
import UAParser from "ua-parser-js";

import { getSiteInfo } from "@/sites";
import { isClient } from "@/utils/browser";

const { domainName } = getSiteInfo(process.env.NEXT_PUBLIC_DOMAIN);

export const initAmplitude = () => {
  const amplitudeKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY || "";

  if (!amplitudeKey || !isClient()) return;

  init(amplitudeKey, undefined, {
    serverZone: "EU",
    autocapture: {
      attribution: true,
      pageViews: false,
      sessions: false,
      formInteractions: false,
      fileDownloads: false,
      pageUrlEnrichment: true,
      elementInteractions: false,
      webVitals: false,
    },
  });

  amplitudeDeviceType();
};

export const amplitudeDeviceType = () => {
  const parser: UAParser = new UAParser();
  const userAgent: UAParser.IResult = parser.getResult();

  let deviceType = "Unknown";
  if (userAgent.device.type === "mobile") {
    deviceType = "Mobile";
  } else if (userAgent.device.type === "tablet") {
    deviceType = "Tablet";
  } else {
    deviceType = "Desktop";
  }

  const identifyEvent = new Identify();
  identifyEvent.set("User Device", deviceType);

  identify(identifyEvent);
};

export const amplitudeTrackEvent = (name: string, data?: Record<string, any>) => {
  if (process.env.NEXT_PUBLIC_ENV === "local") return;

  const identifyEvent = new Identify();
  identifyEvent.set("domain", domainName);
  identify(identifyEvent);

  const eventData = { ...data };
  track(name, eventData);
};

export const amplitudeTrackUser = (userId: string) => {
  if (process.env.NEXT_PUBLIC_ENV === "local") return;
  setUserId(userId);
  const ident = new Identify().set("User Id", userId);
  identify(ident);
};

export const amplitudeLogoutUser = async () => {
  await flush().promise;
  setUserId(undefined);
};
